import { render, staticRenderFns } from "./CustomerArchives.vue?vue&type=template&id=6f1875d7&"
import script from "./CustomerArchives.vue?vue&type=script&lang=js&"
export * from "./CustomerArchives.vue?vue&type=script&lang=js&"
import style0 from "./CustomerArchives.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports